import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

const Intro = ({
  copy,
  emailAddress,
  hasDarkBg,
  hasLightBg,
  hasMinimalPadding,
  headline,
  image,
}) => {
  const containerStyles = cx({
    [styles.container]: true,
    [styles.containerHasDarkBg]: hasDarkBg,
    [styles.containerHasLightBg]: hasLightBg,
    [styles.containerHasMinimalPadding]: hasMinimalPadding,
  });

  return (
    <div className={containerStyles}>
      <div className={styles.grid}>
        <h1 className={styles.headline}>{headline}</h1>
        {copy && (
          <div
            className={styles.copy}
            dangerouslySetInnerHTML={{ __html: copy }}
          />
        )}
        {!!emailAddress && (
          <div className={styles.emailAddressContainer}>
            <a
              href={`mailto:${emailAddress}`}
              target="_blank"
              className={styles.emailAddress}
            >
              {emailAddress}
            </a>
          </div>
        )}
        {!!image && (
          <img src={image.src} alt={image.alt} className={styles.image} />
        )}
      </div>
    </div>
  );
};

export default Intro;



// WEBPACK FOOTER //
// ./src/components/Intro/index.js